import { useEffect } from 'react';
import pkceChallenge from 'pkce-challenge'; // Import the library

const Login = () => {

    useEffect(() => {
        const handleRedirect = async () => {
           
                const { code_verifier, code_challenge } =await pkceChallenge();
                sessionStorage.setItem('code_verifier', code_verifier);

                const clientId = process.env.REACT_APP_IDP_CLIENT_ID;
                const tenantId = process.env.REACT_APP_IDP_TENANT_ID;
                const baseUrl = process.env.REACT_APP_IDP_BASE_URL;
                const redirectUri = encodeURIComponent(process.env.REACT_APP_IDP_REDIRECT_URI);
                const scope = encodeURIComponent(process.env.REACT_APP_IDP_SCOPE);
                const state = encodeURIComponent(sessionStorage.getItem('pathtoRedirect') || '/'); // Use the stored path or default to '/'

                const authUrl = `${baseUrl}/${tenantId}/oauth2/v2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}&code_challenge=${code_challenge}&code_challenge_method=S256`;

                // Redirect to the IDP authorization URL
                window.location.href = authUrl;
            
        };

        handleRedirect();
    });
};

export default Login;